module.exports = __webpack_public_path__ + "img/lens-167-minus-05.5e57d230.png";